import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  container: {
    margin: '0px auto',
    padding: '0 0 50px',
    maxWidth: '400px',
    textAlign: 'center',
  },
  title: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    textAlign: 'left',
  },
  subHeader: {
    paddingBottom: theme.spacing(3),
    textAlign: 'left',
    fontFamily: 'Raleway',
    fontWeight: 300,
    color: '#444',
    fontSize: '16px',
  },
  footerText: {
    margin: theme.spacing(2, 0),
    fontFamily: 'Raleway',
    fontWeight: 300,
  },

  footerLink: {
    fontSize: '16px',
    margin: theme.spacing(2, 0),
  },
  textContainer: {
    flex: '1',
  },
  formContainer: {
    paddingBottom: theme.spacing(1),
  },
});

export default withStyles(styles);
